// src/components/network/layouts/MobileNetworkNav.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Newspaper, Users, MessageSquare, User, LogIn } from 'lucide-react';
import { useNetwork } from '../../../context/NetworkContext';

const MobileNetworkNav = ({ activeView, onChangeView, currentUser }) => {
  const { unreadMessages } = useNetwork();
  
  return (
    <div className="fixed bottom-0 left-0 right-0 w-[100%] bg-white border-t border-gray-200 lg:hidden z-30">
      <div className="flex justify-around">
        <button
          onClick={() => onChangeView('feed')}
          className={`flex flex-col items-center p-3 ${
            activeView === 'feed' ? 'text-[#190192]' : 'text-gray-500'
          }`}
        >
          <Newspaper size={20} />
          <span className="text-xs mt-1">Feed</span>
        </button>
        
        <button
          onClick={() => onChangeView('suggestions')}
          className={`flex flex-col items-center p-3 ${
            activeView === 'suggestions' ? 'text-[#190192]' : 'text-gray-500'
          }`}
        >
          <Users size={20} />
          <span className="text-xs mt-1">Discover</span>
        </button>
        
        <button
          onClick={() => onChangeView('messages')}
          className={`flex flex-col items-center p-3 relative ${
            activeView === 'messages' ? 'text-[#190192]' : 'text-gray-500'
          }`}
        >
          <MessageSquare size={20} />
          {unreadMessages > 0 && (
            <span className="absolute top-2 right-6 bg-red-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">
              {unreadMessages > 9 ? '9+' : unreadMessages}
            </span>
          )}
          <span className="text-xs mt-1">Messages</span>
        </button>

        <Link
          to={currentUser ? '/profile' : '/login'}
          className="flex flex-col items-center p-3 text-gray-500"
        >
          {currentUser ? <User size={20} /> : <LogIn size={20} />}
          <span className="text-xs mt-1">{currentUser ? 'Profile' : 'Sign In'}</span>
        </Link>
      </div>
    </div>
  );
};

export default MobileNetworkNav;
